import { render, staticRenderFns } from "./GInvoice.vue?vue&type=template&id=500c9b3a"
import script from "./GInvoice.vue?vue&type=script&lang=js"
export * from "./GInvoice.vue?vue&type=script&lang=js"
import style0 from "./GInvoice.vue?vue&type=style&index=0&id=500c9b3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports